import React, { createContext, useContext, useEffect, useState } from "react";
import { useLoading } from "../loadingcontext";
import { postData } from "../../pages/Utils/Baseurl";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext();

export default function AuthContextProvider({ children }) {
  const navigate = useNavigate();
  const [authenticated, setAuthenticated] = useState(() => {
    const storedAuth = JSON.parse(localStorage.getItem("authenticated"));
    return storedAuth || false;
  });

  const [currentUser, setCurrentUser] = useState(() => {
    return JSON.parse(sessionStorage.getItem("currentUser")) || null;
  });
  const [rolePermission, setRolePermission] = useState(() => {
    return JSON.parse(sessionStorage.getItem("role")) || null;
  });
  const { setCirleLoading } = useLoading();

  // useEffect(() => {
  //   localStorage.setItem("authenticated", JSON.stringify(authenticated));
  //   localStorage.setItem("currentUser", JSON.stringify(currentUser));
  // }, [authenticated, currentUser]);
  useEffect(() => {
    if (rolePermission) {
      sessionStorage.setItem("role", JSON.stringify(rolePermission));
    }
  }, [rolePermission]);

  useEffect(() => {
    if (!rolePermission) {
      const storedRole = sessionStorage.getItem("role");
      if (storedRole) {
        setRolePermission(JSON.parse(storedRole));
      }
    }
  }, []);
  const login = (user) => {
    setAuthenticated(true);
    setCurrentUser(user);
  };

  const logout = async () => {
    const token = sessionStorage.getItem("refresh_token");
    const formdata = new FormData();
    formdata.append("refresh", token);
    setCirleLoading(true);
    try {
      const res = await postData("api/logout/", formdata);

      navigate("/sign-in");
      localStorage.clear();
      setAuthenticated(false);
      setCurrentUser(null);
      setRolePermission(null);
      sessionStorage.clear();
    } catch (error) {
    } finally {
      setCirleLoading(false);
    }
  };

  return (
    <AuthContext.Provider
      value={{
        authenticated,
        setAuthenticated,
        currentUser,
        setCurrentUser,
        login,
        logout,
        setRolePermission,
        rolePermission,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => {
  return useContext(AuthContext);
};
